import React from "react";
import cx from "classnames";

type Props = {
  className?: string;
};

const IconPinterest = ({ className }: Props) => (
  <svg
    width="32"
    height="32"
    xmlns="http://www.w3.org/2000/svg"
    className={cx("shareLink shareLink--pinterest", className)}
  >
    <path
      d="M16 0C7.172 0 0 7.16 0 15.973c0 6.554 3.917 12.172 9.6 14.65-.055-1.101 0-2.478.276-3.69.33-1.322 2.041-8.702 2.041-8.702s-.496-1.047-.496-2.534c0-2.368 1.379-4.13 3.09-4.13 1.434 0 2.151 1.1 2.151 2.423 0 1.432-.938 3.635-1.434 5.673-.387 1.707.827 3.084 2.537 3.084 3.035 0 5.076-3.91 5.076-8.482 0-3.525-2.372-6.114-6.675-6.114-4.856 0-7.89 3.636-7.89 7.656 0 1.377.386 2.369 1.048 3.14.276.33.331.495.22.88-.054.276-.275.992-.33 1.268-.11.385-.442.55-.828.385-2.262-.936-3.255-3.36-3.255-6.114 0-4.516 3.807-9.969 11.42-9.969 6.125 0 10.152 4.407 10.152 9.143 0 6.28-3.475 10.96-8.606 10.96-1.71 0-3.366-.936-3.918-1.982 0 0-.938 3.69-1.103 4.406-.331 1.212-.993 2.479-1.6 3.415 1.434.44 2.98.661 4.524.661 8.828 0 16-7.16 16-15.973C32 7.215 24.828 0 16 0"
      fill="#B1B5B6"
      fillRule="nonzero"
    />
  </svg>
);

export default IconPinterest;
